// extracted by mini-css-extract-plugin
export default {"faq":"FAQSection_faq__gYBVO","list":"FAQSection_list__tpEA7","item":"FAQSection_item__b-kHv","q":"FAQSection_q__ajvE5","arrow":"FAQSection_arrow__ifLtF","a":"FAQSection_a__5pwPX"};